import _ from 'lodash';
import env from '../../env';
import { AppClientId } from '../Shared/constants';
import * as installationConstants1 from './installations/1/constants';
import * as installationConstants2 from './installations/2/constants';
import * as installationConstants3 from './installations/3/constants';
import * as installationConstants4 from './installations/4/constants';
import * as installationConstants6 from './installations/6/constants';
import * as installationConstants7 from './installations/7/constants';
import * as installationConstants8 from './installations/13/constants';
let installationConstants;
switch (env.clientId) {
  case AppClientId.INDEWAL:
    installationConstants = installationConstants1;
    break;
  case AppClientId.IDWLEASE:
    installationConstants = installationConstants1;
    break;
  case AppClientId.HARRY_NIJBOER:
    installationConstants = installationConstants2;
    break;
  case AppClientId.HOOIKAMMER:
    installationConstants = installationConstants3;
    break;
  case AppClientId.IDW_GMBH:
    installationConstants = installationConstants4;
    break;
  case AppClientId.AUTOWIENTJES:
    installationConstants = installationConstants6;
    break;
  case AppClientId.AUTOHUISSALLAND:
    installationConstants = installationConstants7;
    break;
  case AppClientId.HILTERMANN:
    installationConstants = installationConstants8;
    break;
  default:
    installationConstants = installationConstants1;
}

export const VEHICLES_DOMAIN = 'app/modules/Contents/VEHICLES_DOMAIN';

export const REQUEST_VEHICLES = 'app/modules/Contents/REQUEST_VEHICLES';
export const REQUEST_VEHICLE = 'app/modules/Contents/REQUEST_VEHICLE';
export const REQUEST_VEHICLE_PROPERTY_UPDATE = 'app/modules/Contents/REQUEST_VEHICLE_PROPERTY_UPDATE';
export const REQUEST_VEHICLE_PROPERTY_DELETE = 'app/modules/Contents/REQUEST_VEHICLE_PROPERTY_DELETE';
export const REQUEST_VEHICLE_ASSIGN_TRANSPORT = 'app/modules/Contents/REQUEST_VEHICLE_ASSIGN_TRANSPORT';
export const REQUEST_BULK_ACTION_VEHICLE_ASSIGN_TRANSPORT =
  'app/modules/Contents/REQUEST_BULK_ACTION_VEHICLE_ASSIGN_TRANSPORT';
export const REQUEST_VEHICLE_COMPLETE_TRANSPORT = 'app/modules/Contents/REQUEST_VEHICLE_COMPLETE_TRANSPORT';
export const REQUEST_VEHICLE_DOWNLOAD_IMAGES = 'app/modules/Contents/REQUEST_VEHICLE_DOWNLOAD_IMAGES';
export const REQUEST_VEHICLE_DOCUMENTS_BY_TYPE = 'app/modules/Contents/REQUEST_VEHICLE_DOCUMENTS_BY_TYPE';
export const REQUEST_VEHICLES_DOCUMENTS_BY_TYPE = 'app/modules/Contents/REQUEST_VEHICLES_DOCUMENTS_BY_TYPE';
export const REQUEST_ADD_SUPPLIER = 'app/modules/Contents/REQUEST_ADD_SUPPLIER';
export const REQUEST_REMOVE_SUPPLIER = 'app/modules/Contents/REQUEST_REMOVE_SUPPLIER';
export const REQUEST_VEHICLE_PROPERTY_NAMES = 'app/modules/Contents/REQUEST_VEHICLE_PROPERTY_NAMES';
export const REQUEST_VEHICLE_PROPERTY = 'app/modules/Contents/REQUEST_VEHICLE_PROPERTY';
export const REQUEST_VEHICLE_CREATE = 'app/modules/Contents/REQUEST_VEHICLE_CREATE';
export const REQUEST_VEHICLE_FROM_AUTOTELEX = 'app/modules/Contents/REQUEST_VEHICLE_FROM_AUTOTELEX';
export const REQUEST_AUTOTELEX_APPLY_OPTIONS = 'app/modules/Contents/REQUEST_AUTOTELEX_APPLY_OPTIONS';
export const REQUEST_AUTOTELEX_SEARCH = 'app/modules/Contents/REQUEST_AUTOTELEX_SEARCH';
export const REQUEST_IMPORT_VEHICLE = 'app/modules/Contents/REQUEST_IMPORT_VEHICLE';
export const REQUEST_VEHICLE_BPM_ESTIMATE = 'app/modules/Contents/REQUEST_VEHICLE_BPM_ESTIMATE';
export const REQUEST_VEHICLE_SEARCH_SETTINGS = 'app/modules/Contents/REQUEST_VEHICLE_SEARCH_SETTINGS';
export const REQUEST_UPDATE_VEHICLE_SEARCH_SETTINGS = 'app/modules/Contents/REQUEST_UPDATE_VEHICLE_SEARCH_SETTINGS';
export const REQUEST_BPM_PRICE_LIST = 'app/modules/Contents/REQUEST_BPM_PRICE_LIST';
export const REQUEST_VEHICLE_ADD_TO_OUTGOING_ORDER = 'app/modules/Contents/REQUEST_VEHICLE_ADD_TO_OUTGOING_ORDER';
export const SET_VEHICLE_LOCATION = 'app/modules/Contents/SET_VEHICLE_LOCATION';
export const HEXON = 'app/modules/Contents/HEXON';
export const HEXON_WEBSITES = 'app/modules/Contents/HEXON_WEBSITES';
export const HEXON_ADS_FOR = 'app/modules/Contents/HEXON_ADS_FOR';
export const HEXON_IMAGES_FOR = 'app/modules/Contents/HEXON_IMAGES_FOR';
export const HEXON_DELETE_IMAGE = 'app/modules/Contents/HEXON_DELETE_IMAGE';
export const HEXON_RECREATE_IMAGES = 'app/modules/Contents/HEXON_RECREATE_IMAGES';
export const REQUEST_DELETE_VEHICLE = 'app/modules/Contents/REQUEST_DELETE_VEHICLE';
export const REQUEST_VEHICLE_HISTORY = 'app/modules/Contents/REQUEST_VEHICLE_HISTORY';
export const UPDATE_HISTORY_FILTER = 'app/modules/Contents/UPDATE_HISTORY_FILTER';
export const UPDATE_HISTORY_SEARCH_STRING = 'app/modules/Contents/UPDATE_HISTORY_SEARCH_STRING';

export const REQUEST_VEHICLE_FILTER = 'app/modules/Contents/REQUEST_VEHICLE_FILTER';
export const REQUEST_VEHICLE_FILTER_RESET = 'app/modules/Contents/REQUEST_VEHICLE_FILTER_RESET';
export const APPLY_VEHICLE_FILTERS = 'app/modules/Contents/APPLY_VEHICLE_FILTERS';
export const UPDATE_VEHICLE_FILTERS = 'app/modules/Contents/UPDATE_VEHICLE_FILTERS';
export const UPDATE_VEHICLE_SEARCH_STRING = 'app/modules/Contents/UPDATE_VEHICLE_SEARCH_STRING';
export const SET_VEHICLES_SORT = 'app/modules/Contents/SET_VEHICLES_SORT';

export const FILTER_DEFAULT_LIMIT = 50;
export const REQUEST_VEHICLE_OPTION_DELETE = 'app/modules/Contents/REQUEST_VEHICLE_OPTION_DELETE';

export const SET_NEW_VEHICLE_VALUE = 'app/modules/Contents/SET_NEW_VEHICLE_VALUE';
export const SET_NEW_VEHICLE = 'app/modules/Contents/SET_NEW_VEHICLE';
export const SET_NEW_VEHICLE_OPTIONS = 'app/modules/Contents/SET_NEW_VEHICLE_OPTIONS';
export const RETRIEVE_REGPLATE = 'app/modules/Contents/RETRIEVE_REGPLATE';
export const INITIATE_VEHICLE_EDIT = 'app/modules/Contents/INITIATE_VEHICLE_EDIT';
export const INITIATE_VEHICLE_CREATE = 'app/modules/Contents/INITIATE_VEHICLE_CREATE';
export const INITIATE_NEW_ORDER_CREATE = 'app/modules/Contents/INITIATE_NEW_ORDER_CREATE';
export const SET_NEW_ORDER_VALUE = 'app/modules/Contents/SET_NEW_ORDER_VALUE';

export const CALCULATE_PURCHASE_PRICES_BTW = 'app/modules/Contents/CALCULATE_PURCHASE_PRICES_BTW';
export const CALCULATE_PURCHASE_PRICES_MARGE = 'app/modules/Contents/CALCULATE_PURCHASE_PRICES_MARGE';
export const CALCULATE_PURCHASE_PRICES_INCL_VAT_EXCL_BPM =
  'app/modules/Contents/CALCULATE_PURCHASE_PRICES_INCL_VAT_EXCL_BPM';

export const FETCH_MMT = 'app/Vehicle/FETCH_MMT';
export const MMT = 'app/Vehicle/MMT';

export const REQUEST_GENERATE_INCOMING_INVOICE = 'app/modules/Contents/REQUEST_GENERATE_INCOMING_INVOICE';
export const REQUEST_GENERATE_OUTGOING_INVOICE = 'app/modules/Contents/REQUEST_GENERATE_OUTGOING_INVOICE';
export const REQUEST_GENERATE_INCOMING_BPM_INVOICE = 'app/modules/Contents/REQUEST_GENERATE_INCOMING_BPM_INVOICE';
export const REQUEST_GENERATE_OUTGOING_BPM_INVOICE = 'app/modules/Contents/REQUEST_GENERATE_OUTGOING_BPM_INVOICE';
export const REQUEST_VEHICLE_OUTGOING_BPM_CALCULATION = 'app/modules/Contents/REQUEST_VEHICLE_OUTGOING_BPM_CALCULATION';
export const REQUEST_VEHICLE_OPTIONS = 'app/modules/Contents/REQUEST_VEHICLE_OPTIONS';
export const COPY_VEHICLE_OPTIONS_TO_TARGET_VEHICLE = 'app/modules/Contents/COPY_VEHICLE_OPTIONS_TO_TARGET_VEHICLE';
export const COPY_VEHICLE_GENERAL_PHOTOS_TO_TARGET_VEHICLE =
  'app/modules/Contents/COPY_VEHICLE_GENERAL_PHOTOS_TO_TARGET_VEHICLE';
export const REQUEST_VEHICLE_PROPERTIES = 'app/modules/Contents/REQUEST_VEHICLE_PROPERTIES';
export const ALL_OPTIONS = 'app/modules/Contents/ALL_OPTIONS';
export const REQUEST_VEHICLE_TASKS = 'app/modules/Contents/REQUEST_VEHICLE_TASKS';

export const REQUEST_PRODUCT_INVOICES = 'app/modules/Contents/REQUEST_PRODUCT_INVOICES';

export const ADD_VEHICLE_TO_BULK_ACTIONS_LIST = 'app/modules/Contents/ADD_VEHICLE_TO_BULK_ACTIONS_LIST';
export const REMOVE_VEHICLE_FROM_BULK_ACTIONS_LIST = 'app/modules/Contents/REMOVE_VEHICLE_FROM_BULK_ACTIONS_LIST';
export const REMOVE_ALL_VEHICLE_FROM_BULK_ACTIONS_LIST = 'app/modules/Contents/REMOVE_ALL_VEHICLE_FROM_BULK_ACTIONS_LIST';
export const REQUEST_UPDATE_SELECTED_VEHICLES = 'app/modules/Contents/REQUEST_UPDATE_SELECTED_VEHICLES';
export const SHARE_EXCEL_VEHICLE_DATA = 'app/modules/Contents/SHARE_EXCEL_VEHICLE_DATA';
export const REQUEST_DOWNLOAD_ZIP_FILES = 'app/modules/Contents/REQUEST_DOWNLOAD_ZIP_FILES';
export const REQUEST_ADD_EXTRA_COST_BULK = 'app/modules/Contents/REQUEST_ADD_EXTRA_COST_BULK';
export const FETCH_HEMEX_STATUS = 'app/modules/Contents/FETCH_HEMEX_STATUS';
export const CREATE_HEMEX_INSPECTION = 'app/modules/Contents/CREATE_HEMEX_INSPECTION';
export const HEMEX_STATUS = 'app/modules/Contents/HEMEX_STATUS';

export const REQUEST_SILVERDAT_GET = 'app/modules/Contents/REQUEST_SILVERDAT_GET';
export const REQUEST_CAR_COLLECT = 'app/modules/Contents/REQUEST_CAR_COLLECT';
export const REQUEST_CAR_COLLECT_CREATE = 'app/modules/Contents/REQUEST_CAR_COLLECT_CREATE';
export const REQUEST_CAR_COLLECT_AWARDS = 'app/modules/Contents/REQUEST_CAR_COLLECT_AWARDS';
export const ADD_CAR_COLLECT_INVOICE = 'app/modules/Contents/ADD_CAR_COLLECT_INVOICE';
export const ADD_CAR_COLLECT_DOCUMENT = 'app/modules/Contents/ADD_CAR_COLLECT_DOCUMENT';
export const SILVERDAT_DATA = 'app/modules/Contents/SILVERDAT_DATA';

export const REQUEST_OREH_VEHICLE_EXPORT = 'app/modules/Contents/REQUEST_OREH_VEHICLE_EXPORT';

export const REQUEST_VEHICLE_RECOMMENDATIONS = 'app/modules/Contents/REQUEST_VEHICLE_RECOMMENDATIONS';
export const SWITCH_VEHICLE_RDW_DATES = 'app/modules/Contents/SWITCH_VEHICLE_RDW_DATES';
export const COPY_VEHICLE = 'app/modules/Contents/COPY_VEHICLE';

// Workflow management
export const REQUEST_VEHICLE_WORKFLOW_TASKS = 'app/modules/Contents/REQUEST_VEHICLE_WORKFLOW_ACTIONS';
export const ASSIGN_WORKFLOW_TO_VEHICLE = 'app/modules/Contents/ASSIGN_WORKFLOW_TO_VEHICLE';

// prettier-ignore
export const VEHICLE_EXTRA_COST = _.chunk(env.VEHICLE_EXTRA_COST || [

    "Title Wallstreet", 0,
    "Claim filing external", null,
    "Private collection", null,
    "Interior cleaning", null,
    "Mounting license plate", 35,
    "soh rapport", 50,
    "Restyle Plans", null,
    "Spraypainting plans", null,
    "Interior Polishing Plans", null,
    "Interior Repair Plans", null,
    "Spot Repair Plans", null,
    "Unsticking Plans", null,
    "Interior Exterior Polishing Plans",null,
    "Exterior Polishing Plans", null,
    "Update Plans", null,
"Title Workshop", 0,
    "Windshield Repair Plans", null,
    "Repair Plans", null,
    "Tire exchange", null,
     "Schedule an Overhaul", null,
    "MOT Plans", null,
    "Onderdelen", null,
    "Workshop costs", null,
    "Warranty costs", null,
    "Popnagels", null,
"Title Administration", 0,
     "Vehicle registration", null,
    "Do a BPM declaration", null,
    "Call in an appraiser", null,
    "Registering the vehicle for export", null,
    "Export with export plates", null,
    "Apply for a German letter", null,
    "Export tasks", null,
    "CVO CoC aanvraag", null,
"Title Transport", 0,
    "transport intern incoming", null,
    "transport intern individual", null,
    "transport intern outgoing", null,
    "Transfer to Weeze", null,
   "Transport kosten inkomend", null,
    "Transport kosten uitgaand", null,
     "Transportation costs", null,
"Title Finance", 0,
    "Interest", null,
    "Sales fee", null,
    "Purchase fee", null,
    "Inkomende claim koper", null,
    "Other", null,
], 2).map(pair => {
    if (pair[0] == "Interest") {
        return { name: `extra_costs_${pair[0].replace(/ /g, '_').toLowerCase()}`, amount: pair[1] }
    }

    return { name: `extra_cost_${pair[0].replace(/ /g, '_').toLowerCase()}`,
    amount: pair[1],
    isTitle: pair[0].toLowerCase().includes("title")
    };
})

// .reduce( (a,v) => {
//   a[v.name.replace(/ /g, '_').toLowerCase()] = v.amount;
//   return a;
// },{});

export const VEHICLE_TASK_FIELDS =
  env.clientId === AppClientId.AUTOWIENTJES
    ? {
        task_wash: '0',
        task_polish_showroom: '0',
        task_desticker: '0',
        task_restyle: '0',
        task_spray: '0',
        task_window_repair: '0',
        task_seat_repair: '0',
        task_extra_key: '0',
        task_apk: '0',
        task_workshop: '0',
      }
    : env.clientId === AppClientId.AUTOHUISSALLAND
    ? {
        SALLAND_poetsen_compleet: '0',
        SALLAND_poetsen_buitenkant: '0',
        SALLAND_poetsen_binnenkant: '0',
        SALLAND_velgen_wisselen: '0',
        SALLAND_ozon_behandeling: '0',
        SALLAND_glascoating: '0',
        SALLAND_losse_taak: '0',
      }
    : {
        task_interior_polish: '0',
        task_polish_exterior: '0',
        task_restyle: '0',
        task_spray: '0',
        task_attach_replate: '0',
        task_int_ext_polish: '0',
        task_adjust: '0',
        task_desticker: '0',
        task_service: '0',
        task_apk: '0',
        task_recall: '0',
        task_window_repair: '0',
        task_spot_repair: '0',
        task_interior_repair: '0',
        task_repair: '0',
        task_nijboer: '0',
        task_AVN: '0',
        task_hartstad: '0',
        task_ijsseldelta: '0',
        task_attach_parts: '0',
      };

export const DEFAULTS_TASK_FIELDS = {
  task_label: '1',
  task_test_drive: '1',
  task_interior_inspection: '1',
  task_interior_clean: '1',
  task_interior_pictures: '1',
  task_interio_pictures: '1',
  task_exterior_inspection: '1',
  task_exterior_edit: '1',
  task_exterior_pictures: '1',
};

export const VEHICLE_BRANDS = [
  'Alfa Romeo',
  'Aston Martin',
  'Audi',
  'Bentley',
  'BMW',
  'Bugatti',
  'Cadillac',
  'Chevrolet',
  'Chevrolet USA',
  'Chrysler',
  'Citroen',
  'Corvette',
  'Dacia',
  'Daihatsu',
  'Dodge',
  'Donkervoort',
  'Ferrari',
  'Fiat',
  'Fisker',
  'Ford',
  'Honda',
  'Hyundai',
  'Infiniti',
  'Jaguar',
  'Jeep',
  'Kia',
  'Lamborghini',
  'Lancia',
  'Land Rover',
  'Landwind',
  'Lexus',
  'Lotus',
  'Maserati',
  'Maybach',
  'Mazda',
  'McLaren',
  'Mercedes-Benz',
  'Mini',
  'Mitsubishi',
  'Morgan',
  'Nissan',
  'Opel',
  'Peugeot',
  'Porsche',
  'Renault',
  'Rolls-Royce',
  'Saab',
  'SEAT',
  'Skoda',
  'smart',
  'Spyker',
  'SsangYong',
  'Subaru',
  'Suzuki',
  'Tesla',
  'Think',
  'Toyota',
  'Volkswagen',
  'Volvo',
];

export const VEHICLE_MODELS = {
  volkswagen: [
    'Beetle',
    'Beetle Cabriolet',
    'Caddy',
    'Caddy Maxi',
    'CC',
    'Eos',
    'e-Up!',
    'Golf',
    'Golf Cabriolet',
    'Golf Plus',
    'Golf Variant',
    'Jetta',
    'Passat',
    'Passat Alltrack',
    'Passat CC',
    'Passat Variant',
    'Phaeton',
    'Polo',
    'Scirocco',
    'Sharan',
    'Tiguan',
    'Touareg',
    'Touran',
    'Up!',
    'Arteon',
    'Arteon Shooting Brake',
    'e-Golf',
    'Golf Sportsvan',
    'ID.3',
    'ID.4',
    'T-Cross',
    'Tiguan Allspace',
    'T-Roc',
    'T-Roc Cabrio',
  ],
};

export const VEHICLE_BODY_TYPES = [
  'Hatchback',
  'Cabrio',
  'Coupe',
  'SUV',
  'Sedan',
  'Stationwagen',
  'van',
  'MPV',
  'other',
].map(t => t.toLowerCase().replace(/ /g, ''));

export const VEHICLE_FUEL_TYPES = [
  'CNG',
  'Diesel',
  'electric',
  'electric/Diesel',
  'electric/gasoline',
  'hybride benzine',
  'Ethanol',
  'Benzine',
  'Waterstof',
  'LPG',
  'Other',
].map(t => (t === 'hybride benzine' ? t.toLowerCase() : t.toLowerCase().replace(/ /g, '')));

export const VEHICLE_COLORS = [
  'Rood',
  'Oranje',
  'Geel',
  'Groen',
  'Blauw',
  'Paars',
  'Roze',
  'Bruin',
  'Grijs',
  'Zwart',
  'Wit',
  'Beige',
  // 'red',
  // 'orange',
  // 'yellow',
  // 'green',
  // 'blue',
  // 'paars',
  // 'pink',
  // 'brown',
  // 'gray',
  // 'black',
  // 'white',
];

export const VEHICLE_MILEAGE_CATEGORIES = [
  'PW New',
  'PW <60,000 km',
  'PW <100,000 km',
  'PW <150,000 km',
  'PW <250,000 km',
  'PW >250,000 km',
  'BW New',
  'BW <60,000 km',
  'BW <150,000 km',
  'BW >150,000 km',
];

export const VEHICLE_FIRST_STEP_FIELD_TYPES = [
  'regplate',
  'vin',
  'mileage',
  'new_from_factory',
  'ex_rental',
  
  'creditor_company',
  'creditor',
  'transport',
  'date_expected',
  'brand_name',
  'model_name',
  'model_info',
  'date_first_allowance',
  'body_type',
  'base_color',
  'secondary_color',
  'transmission_type',
  'fuel_type',
  'power',
  'import',
  'power_axle',
  'battery_capacity',
  'nedcCo2Emission',
  'wltpCo2Emission',
];

export const VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_MARGE =
  installationConstants?.VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_MARGE;

export const VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_BTW = installationConstants?.VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_BTW;

export const WIENTJES_VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_BTW = [
  'economic_prize',
  'financial_purchase_price_incl_vat_bpm',
  'financial_purchase_price_incl_vat_excl_bpm',
  'vat_amount',
  'financial_purchase_price_excl_vat_excl_bpm',
  'rest_bpm',
  // 'vat_percentage',
  // 'financial_bpm_gross',
];

export const VEHICLE_SECOND_STEP_FIELD_TYPES = [
  'buying_company',
  'buying_contact',
  'sales_preferred_vehicle',
  'tax_type',
  'financial_price_b2c',
  'financial_price_b2b_incl_vat_btpm',
  'financial_price_gross_incl_btw_bpm',
  'financial_price_nett_excl_vat_bpm',
  'vehicle_purpose',
  ...VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_BTW,
  ...VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_MARGE,
];

export const VEHICLE_THIRD_STEP_FIELD_TYPES = [
  'date_first_allowance',
  'last_tenaamstelling',
  'number_of_previous_owners',
  'date_apk_expiry',
  'wok',
  'pending_recall',
  'model_year',
  'production_date',
  'delivered_from',
  'design',
];

export const VEHICLE_FIFTH_STEP_FIELD_TYPES = [
  'cyllinder_capacity',
  'number_of_cillinders',
  'acceleration_0_100',
  'topspeed',
  'torque',
  'wheelbase',
  'vehicle_length',
  'vehicle_width',
  'vehicle_height',
  'loadingspace',
  'tank_contents',
  'tank_capacity',
  'weight_driveready',
  'empty_weight',
  'max_allowed_weight',
  'technical_max_weight_vehicle',
  'allowed_max_weight_vehicle',
  'warranty_type',
  'warranty_period',
  'number_of_seats',
  'interior_color',
  'interior_type',
  'number_of_doors',
  'primary_exterior_color_factory_name',
  'secondary_exterior_color_factory_name',
  'number_of_gears',
  'number_of_axles',
  'power_axle',
  'placecode_as',
  'trackwidth',
  'drive_code',
  'technical_allowed_axle_load',
  'legally_allowed_axle_load',
  'vin_number_location',

  'trailer_with_brakes',
  'trailer_without_brakes',
  'middleaxle_trailer_with_brakes',
  'middleaxle_trailer_without_brakes',
  'autonomous_trailer_with_brakes',
  'trailercarrier_with_brakes',

  'vehicleType',
  'taxadditions_percentage',
  'taxaddion_until',
  'catalogprice_incl_options',
  'catalogprice_excl_options',
  'delivery_costs',
  'intrastat_goods_code',
  'approvalNumber',

  'energy_label',
  'euro_class',
  'average_consumption_combined',
  'average_highway_consumption',
  'average_city_consumption',
  'consumption_KwH',
  'max_chargingspeed_DC',
  'particulate',
  'is_imported',
];

export const VEHICLE_ADD_MODALS_TYPES = [
  'creditor',
  'creditor_company',
  'regplate',
  'vin',
  'vehicle_purpose',
  'sales_preferred_vehicle',
  'import',
  'brand_name',
  'model_name',
  'buying_contact',
  'tax_type',
  'financial_price_b2c',
  'financial_purchase_price_incl_vat_excl_bpm',
  'transport',
  'date_expected',
  'financial_purchase_price_marge_bpm',
  'financial_price_b2b_incl_vat_btpm',
  'financial_purchase_price_excl_vat_excl_bpm',
  'financial_purchase_price_incl_vat_bpm',
  'transport_from_address_id',
  'transport_to_address_id',
  'transport_incoming_from_company_id',
  'transport_incoming_to_company_id',
  'transport_incoming_from_company_name',
  'transport_incoming_to_company_name',
  'transport_direction',
  'transport_is_nl',
  'transport_incoming_is_nl',
  'transport_requested',
];

export const VEHICLE_DETAILS_VEHICLE_DATA_CARD = installationConstants?.VEHICLE_DETAILS_VEHICLE_DATA_CARD;

export const VEHICLE_DETAILS_SALESCARD = installationConstants?.VEHICLE_DETAILS_SALESCARD;

export const VEHICLE_BPM_CARD_TYPES = ['indication_rest_bpm', 'indication_gross_bpm', 'wltpCo2Emission', 'nedcCo2Emission'];

export const VEHICLE_TRANSMISSION_TYPES = ['automaat', 'handmatig'];

export const VEHICLE_DRIVE_TYPES = ['frontwheeldrive', 'rearwheeldrive', 'frontback', 'other'];

export const INTERIOR_PREVIEW_VALUES = [
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
];

export const EXTERIOR_PREVIEW_VALUES = [1, 2, 3, 4];

export const PRICE_TYPES = {
  EXCL_VAT_BPM: 'excl.BTW/BPM',
  INCL_VAT_BPM: 'incl.BTW(Or Margin)/BPM',
};

export const VEHICLE_PURPOSE = {
  PropertyName: 'vehicle_purpose',
  Passenger: 'passenger',
  Commercial: 'commercial',
};

export const VEHICLE_PURPOSES = {
  PASSENGER: 'passenger',
  COMMERCIAL: 'commercial',
  TRUCKS_OVER_7500: 'trucks_over_7500',
  BUSSES: 'busses',
  TRAILER: 'trailer',
  SEMI_TRAILERS_TRUCK: 'semi_trailers_truck',
  SEMI_TRAILER: 'semi_trailer',
  FORKLIFT_TRUCKS: 'forklift_trucks',
  MOTORHOME: 'motorhome',
  CONSTRUCTION_MACHINES: 'construction_machines',
  AGRICULTURAL_VEHICLE: 'agricultural_vehicle',
  MICROCARS: 'microcars',
  MOPEDS: 'mopeds',
  BICYCLES: 'bicycles',
  BOATS: 'boats',
  MOTORCYCLES: 'motorcycles',
};
export const PASSENGER_SCENARIO_VEHICLE_PURPOSES = [
  VEHICLE_PURPOSES.PASSENGER,
  VEHICLE_PURPOSES.MOTORCYCLES,
  VEHICLE_PURPOSES.MOTORHOME,
];

export const VEHICLE_TAX_TYPE = {
  PropertyName: 'tax_type',
  BTW: 'BTW',
  Marge: 'marge',
};

export const AUTOTELEX_VEHICLE_PURPOSE = {
  PropertyName: 'rDWVoertuigClassificatie',
  Passenger: 'personenauto',
  Commercial: 'bedrijfsauto',
};

export const EXPORT_IN_EXCEL_PROPERTIES_LIST_COL_1 = [
  'regplate',
  'vin',
  'buying_contact',
  'number_of_axles',
  'brand_name',
  'model_name',
  'model_info',
  'mileage',
  'date_first_allowance',
  'new_from_factory',
  'import',
  'body_type',
  'base_color',
  'secondary_color',
];

export const INTERNAL_STOCKLIST_PRESELECTION = [
  'regplate',
  'vin',
  'brand_name',
  'model_name',
  'model_info',
  'mileage',
  'date_first_allowance',
  'base_color',
  'transmission_type',
  'fuel_type',
  'import',
  'tax_type',
  'vehicle_purpose',
  'buying_contact',
  'status',
];

export const RESET_INTERNAL_PRESELECTION = ['vin', 'import', 'vehicle_purpose', 'buying_contact', 'status'];

export const RESET_EXTERNAL_PRESELECTION = [
  'financial_price_b2b_incl_vat_btpm',
  'financial_price_gross_incl_btw_bpm',
  'financial_price_nett_excl_vat_bpm',
  'action_ws1_1_labels_done',
  'link_to_inspection_report',
];

export const EXTERNAL_LIST_FOR_CUSTOMERS_PRESELECTION = [
  'regplate',
  'brand_name',
  'model_name',
  'model_info',
  'mileage',
  'date_first_allowance',
  'base_color',
  'transmission_type',
  'fuel_type',
  'tax_type',
  'financial_price_b2b_incl_vat_btpm',
  'financial_price_gross_incl_btw_bpm',
  'financial_price_nett_excl_vat_bpm',
  'action_ws1_1_labels_done',
  'link_to_inspection_report',
];

export const EXPORT_IN_EXCEL_PROPERTIES_LIST_COL_2 = installationConstants.EXPORT_IN_EXCEL_PROPERTIES_LIST_COL_2;

export const WS2_1_TESLA_ADDITIONAL_PHOTOS = ['tesla_additional_1', 'tesla_additional_2'];

export const WS2_1_IMPORT_PHOTOS_PASSENGER = [
  'vin_num_of_axels',
  'constraction_plate',
  'counter_clock',
  'left_front',
  'right_back',
];

export const WS2_1_EXTRA_PHOTO_NEW = ['counter_clock', 'constraction_plate'];

export const WS2_1_IMPORT_PHOTOS_COMMERCIAL = [
  'vin_num_of_axels',
  'constraction_plate',
  'counter_clock',
  'tellerklok',
  'left_front',
  'right_back',
  'popnagels_1',
  'popnagels_2',
  'popnagels_3',
];

export const WS2_1_IMPORT_OPTIONS_PHOTOS = [
  'photo_interior_Tellerklok',
  'photo_interior_Betimmering laadruimte',
  'photo_interior_Tussenschot',
  'photo_interior_Kofferruimte',

  'photo_option_Tellerklok',
  'photo_option_Betimmering laadruimte',
  'photo_option_Tussenschot',
  'photo_option_Kofferruimte',


  'photo_general_Tellerklok',
  'photo_general_Betimmering laadruimte',
  'photo_general_Tussenschot',
  'photo_general_Kofferruimte',
];

export const WS2_1_GENERAL_PHOTOS = env.VEHICLE_WS2_1_GENERAL_PHOTOS || [
  'left_front',
  'right_front',
  'right_back',
  'left_back',
  'right_side',
  'left_side',
  'interior_overview',
];

export const WS2_1_IMPRESSION_PHOTOS = [
  'impression_left_front',
  'impression_right_front',
  'impression_left_back',
  'impression_right_back',
  'impression_interior_full',
  'impression_mileage',
  'impression_interior_side',
  'impression_backseat',
  'impression_laadruimte',
  'impression_keys_instruction',
];

export const WS2_1_DAMAGE_POSITIONS = ['front', 'back'];

export const VEHICLE_OPTIONS2 = [
  {
    title: 'front',
  },
  'Koplampreiniging',
  'Mistlampen voor adaptief',
  'Mistlampen voor',
  {
    title: 'side',
  },
  'Buitenspiegels elektrisch verstelbaar',
  'Cabriolet kap',
  'Dakrails',
  'Side-skirts',
  {
    title: 'back',
  },
  'Achterspoiler',
  'Dakspoiler',
  'Laadbak',
  'Laadlift',
  {
    title: 'comfort',
  },
  'Aanhanger assistent',
  'Achteruitrij assistent',
  'Adaptief demping systeem',
  'Afdaal assistent',
  'ABS',
  'Anti doorSlip Regeling',
  'Automatische snelheids begrenzing',
  'Autonomous emergency braking',
  'Bandenspanningscontrolesysteem',
  'Bots waarschuwing systeem',
  'Brake assist system',
  'Elektrisch bedienbare kap',
  'Elektrische stoelen',
  'Elektronisch Stabiliteits Programma',
  'Hill hold functie',
  'Kruisend verkeer detectie',
  'Regensensor',
  'Roll Stability Control',
  'Spraakbediening',
  'Stuurbekrachtiging',
  'Stuurwiel verwarmd',
  'Uitwijk assistent',
  'Vermoeidheids herkenning',
  'Verwarmde voorruit',
  'Voorstoelen in hoogte verstelbaar',
  //{
  //   title: 'interior',
  //  },
  //'alcantara interieurdelen',
  //'aluminium interieur afwerking',
  //'carbonafwerking interieur',
  //'houtafwerking interieur',
  //'velours/alcantara bekleding',

  {
    title: 'multimedia',
  },
  'Bluetooth telefoonvoorbereiding',
  'Draadloze telefoonlader',
  'Radio CD speler',
  'Radio',
  {
    title: 'milieu',
  },
  'Emissienorm Euro 4',
  'Emissienorm Euro 5',
  'Emissienorm Euro 6',
  //'roetfilter',
  {
    title: 'bedrijfswagen',
  },
  'Achterdeuren',
  'Achterklep',
  'Bullbar',
  'Dubbele cabine',
  'Elektrische schuifdeur',
  'Extra zijschuifdeur',
  'Houtvloer',
  'Imperial',
  'Koelwagenuitvoering',
  'Lat-om-lat betimmering laadruimte',
  'Schuifdeur',
  'Sidebars',
  'Treeplanken',
  'Tussenschot',
  'Verhoogd dak',
  'zijschuifdeur_links',
  'schuifdeur_rechts',
  {
    title: 'other',
  },
  '3-persoons uitvoering',
  '4WD',
  'Aardgas installatie',
  'Airbags',
  'Alarm',
  'Buitenspiegels verwarmbaar',
  'Dashboardcamera',
  'Derde zitrij',
  'Keramische remschijven',
  'Kleur parelmoer',
  'LPG installatie',
  'Metaalkleur parelmoer',
  //'Mica kleur',
  '5-persoons uitvoering',
  '6-persoons uitvoering',
  '7-persoons uitvoering',
  '8-persoons uitvoering',
];

export const VEHICLE_OPTIONS_HOOIKAMMER = [
  { title: 'Exterieur' },

  'Camera voor',
  'Lichtmetalen velgen',
  'Metallic lak',
  'Panoramadak',
  'Schuif-kanteldak',
  'Parkeersensoren',
  'Achteruitrijcamera',
  'Trekhaak met vaste kogel',
  'Trekhaak met afneembare kogel',
  'Trekhaak wegklapbare kogel',
  'Luchtvering',
  'Xenon koplampen',
  'LED verlichting',
'Parkeersensoren V+A',
'Elektrische achterklep',

  { title: 'Interieur' },
  'Airco',
        'Semi automatische airco',
  'climate control',
  'Stoelverwarming',
  'Head-up display',
  'Android auto - Apple Carplay',
  'Navigatiesysteem',
  'Lederen bekleding',
  'Cruise control',
  'Cruise control adaptief',
        '7-zitter',
        'Dubbele cabine',
        'Premium audio systeem',

  { title: 'Overig' },
  'has_back_cover',
  'has_charge_cable',
];

export const VEHICLE_OPTIONS_IDW = [
  {
    title: 'interieur',
  },
  'DAB ontvanger',
  'Navigatiesysteem',
  'Apple carplay',
  'Android auto',
  'Virtual Cockpit',
  'Airco',
  'Autopilot',
  'Airco ECC',
  'Standkachel',
  'Cruise control',
  'Cruise control adaptief',
  'Luchtvering',
  'Head-up display',
  'Nachtzicht-assistent',
  'Rijstrooksensor',
  'Verkeersbord detectie',
  'Dodehoek detectie',
  'Camera achter',
  'Camera voor',
  'Rondomzicht camera',
  'Parkeer assistent',
  'Keyless start',
  'Start/stop systeem',
  'autonome parkeerfunctie',
  'Elektrisch bedienbare cabriokap',
  'stoelverwarming voor',
  'Stuurverwarming',
  'Verwarmde voorruit',
  'stoel ventilatie voor',
  'massagestoelen',
  'Buitenspiegels elektrisch inklapbaar',
  'Elektrische spiegels',
  'Hoogte verstelbare bestuurdersstoel',
  'Elektrisch bedienbare stoelen',
  'Armsteun voor',
  'Audio installatie premium',
  'Memory stoelen',
  'Stoffen bekleding',
  'Stof/alcantara bekleding',
  'Alcantara bekleding',
  'Lederen bekleding',
  'Lederen/alcantara bekleding',
  'Lederen/stof bekleding',
  'Sportief interieur',
  'Lederen sportstuur',
  'Lederen stuur',
  'Stuurwiel multifunctioneel',
  'Schakelmogelijkheid stuurwiel',
  'Zwarte hemelbekleding',
  'Schuif-kanteldak',
  'Panoramadak',
  'Keyless entry',
  'Achter interieur',
  'Voor interieur',
  'Isofix bevestiging',
  'Achterbank armsteun',
  'Achterbank verwarmd',
  'stoel ventilatie achter',
  'Airco separaat achter',
  {
    title: 'exterieur',
  },
  'LED achterlichten',
  'Parkeersensor achter',
  'Metallic lak',
  'Two-tone (metaal) kleur',
  'Dakrails',
  'Getint glas',
  'Kofferruimte',
  'Elektrisch bedienbare achterklep',
  'Trekhaak met vaste kogel',
  'Trekhaak met afneembare kogel',
  'Trekhaak wegklapbare kogel',
  'derde zitrij',
  'Bagage-afdekhoes',
  'Lichtmetalen velgen',
  'Hoogte verstelling passagiersstoel',

  'Buitenspiegels carrosseriekleur',
  'Sportpakket',
  'Bi-xenon koplampen',
  'Koplampen adaptief',
  'Laser LED koplampen',
  'LED koplampen',
  'Xenon koplampen',
  'Halogeen koplampen',
  'Parkeersensor voor',
  'Cabriolet kap',
  {
    title: 'Bedrijfswagen',
  },
  'Sidebars',
  'Treeplanken',
  'Zijschuifdeur links',
  'Bullbar',
  'Zijschuifdeur rechts',
  'Elektrische schuifdeur',
  'Dubbele cabine',
  'Achterdeuren',
  'Achterklep',
  'Laadlift',
  'Laadbak',
  'Koelwagenuitvoering',
  'Houtvloer',
  'Betimmering laadruimte',
  'Tussenschot',
  'Kastindeling',
];

export const VEHICLE_OPTIONS = [
  {
    title: 'algemeen',
  },
  '1e Eigenaar',
  '6 versnellingen',
  'Airco ECC',
  'Airco',
  'Apple CarPlay',
  'Android Auto',
  'Armsteun',
  'Bagage-afdekhoes',
  'Camera achter',
  'CV op afstand',
  'Cruise control',
  'Dealer onderhouden',
  'Elektrisch bedienbare achterklep',
  'Elektrische ramen',
  'Elektrische spiegels',
  'Getint glas',
  'Hoogte verstelbare stoel',
  'Isofix bevestiging',
  'Lederen bekleding',
  'Lichtmetalen velgen',
  'Metallic lak',
  'Memory stoelen',
  'Navigatiesysteem',
  'Panoramadak',
  'Parkeersensor achter',
  'Parkeersensor voor',
  'Schuif-kanteldak',
  'Stoelverwarming voor',
  'Stuurwiel multifunctioneel',
  'Trekhaak met vaste kogel',
  'Virtual Cockpit',
  'Xenon koplampen',

  {
    title: 'front',
  },
  'Bi-xenon koplampen',
  //'Halogeen koplampen',
  'Koplampen adaptief',
  'Laser LED koplampen',
  'LED dagrijverlichting',
  'LED koplampen',
  'Parkeersensor voor en achter',
  'Camera voor',
  //'parkeersensor voor',
  {
    title: 'side',
  },
  //'Buitenspiegels carrosseriekleur',
  'Buitenspiegels elektrisch inklapbaar',
  'Dodehoek detectie',
  //'Dubbele cabine',
  //'Extra zijschuifdeur',
  'Luchtvering',
  'Sportonderstel',
  'Sportpakket',
  //'Two-tone (metaal) kleur',

  {
    title: 'back',
  },
  //'Cabriolet kap',
  //'Laadlift',
  'LED achterlichten',
  'Trekhaak met afneembare kogel',
  'Trekhaak wegklapbare kogel',

  {
    title: 'comfort',
  },
  '360° camera',
  'Achteruitrijcamera',
  'Adaptive cruise control',
  'Airco separaat achter',
  'Autopilot',
  'Head-up display',
  'Keyless entry',
  'Keyless start',
  'Lane Assist',
  'Nachtzicht-assistent',
  'Park Assist',
  'Rondomzicht camera',
  'Standkachel',
  'Startonderbreker',
  'Start/stop systeem',
  'Traction Control',
  'Verkeersbord detectie',
  'Verwarmbare voorruit',
  //'achteruitrij assistent',
  //'autonome parkeerfunctie',
  {
    title: 'interior',
  },
  'Achter interieur',
  //'Achterbank armsteun',
  'Achterbank verwarmd',
  'Alcantara bekleding',
  'Kofferruimte',
  'Kunstlederen bekleding',
  'Lederen sportstuur',
  'Lederen stuur',
  'Lederen/alcantara bekleding',
  'Lederen/stof bekleding',
  'Lederen/velours bekleding',
  'Niveauregeling automatisch',
  'Schakelmogelijkheid stuurwiel',
  'Sportief interieur',
  'Stoel ventilatie',
  'Stoffen bekleding',
  'Velours bekleding',
  'Voor interieur',
  'Zonnescherm zijruiten',
  'Zwarte hemelbekleding',
  //'stoelverwarming voor',
  //'voor stoelen verwarmd',
  {
    title: 'multimedia',
  },
  'Audio installatie premium',
  'DAB+ radio',
  'Navigatiesysteem full map',
  // 'Navigatie groot scherm',
  'WLAN / Wifi-hotspot',
];

export const USER_FILTER_LIST = env.user_filter_list || installationConstants.USER_FILTER_LIST;

export const BUYERS_OPTIONS = installationConstants.BUYERS_OPTIONS;
